/**
 * Storage-size formatting shared by the API (error messages), web and mobile
 * ("Photos: 120 MB of 2 GB"). Binary units (1 KB = 1024 bytes) with the
 * familiar KB/MB/GB labels, matching how phones and desktops report sizes.
 */
const UNITS = ['bytes', 'KB', 'MB', 'GB', 'TB'];
/** Human-readable size: 0 → "0 bytes", 125829120 → "120 MB", 2147483648 → "2 GB". */
export function formatBytes(bytes) {
    if (!Number.isFinite(bytes) || bytes <= 0)
        return '0 bytes';
    let value = bytes;
    let unit = 0;
    while (value >= 1024 && unit < UNITS.length - 1) {
        value /= 1024;
        unit++;
    }
    if (unit === 0)
        return `${Math.round(value)} bytes`;
    // One decimal below 10 (1.5 GB), whole numbers above (120 MB); drop a trailing .0.
    const rounded = value < 10 ? Math.round(value * 10) / 10 : Math.round(value);
    if (rounded >= 1024 && unit < UNITS.length - 1)
        return `1 ${UNITS[unit + 1]}`;
    return `${rounded} ${UNITS[unit]}`;
}
export function storageUsage(usedBytes, quotaBytes) {
    const used = Math.max(0, usedBytes);
    const quota = Math.max(0, quotaBytes);
    const fraction = quota === 0 ? 1 : Math.min(1, used / quota);
    return {
        label: `${formatBytes(used)} of ${formatBytes(quota)}`,
        fraction,
        full: used >= quota,
    };
}
//# sourceMappingURL=storage.js.map